import React, { useState, useEffect } from "react";
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { useSearchParams } from "react-router-dom";
import SuccessError from "./Widgets/SuccessError"
import { Fragment } from "react";
//import { useValidationSchema, useMenuItemProps, useHandleMultiSelectChange } from '../hooks/useAppsLogic'
import { UrlRe } from '../hooks/useAppsLogic';
import SelfSizingTextField from "./Widgets/selfSizingTextField";
import Switch from '@mui/material/Switch';
import { FormControlLabel, FormControl, InputLabel, Select, MenuItem, Collapse, Tooltip } from '@mui/material';
import { useHandleMultiSelectChange, useMenuItemProps, handleBooleanRadioButtonChange, handleSubcontractorRadioButtonChange } from '../hooks/useAppsLogic'
import { Controller } from "react-hook-form";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import MultiSelectWithChips from "./Widgets/MultiSelectWithChips";
import _without from "lodash/without";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import OutlinedInput from '@mui/material/OutlinedInput';
import ListItemText from '@mui/material/ListItemText';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import '../custom.css';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import MuiToggleButton from '@mui/material/ToggleButton';
import { styled } from "@mui/material/styles";
import HelpCenterOutlinedIcon from '@mui/icons-material/HelpCenterOutlined';
import { max, set } from "lodash";

//import useGridColumnSetup, { useSavePia, useValidationSchema, useFetchApplications, useMenuItemProps, useHandleMultiSelectChange, handleCloudHostedChange } from '../hooks/useAppsLogic'
//import { Stack, Alert, Collapse, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Tooltip } from '@mui/material';
const ToggleButton = styled(MuiToggleButton)(({ selectedColor }) => ({
    '&.Mui-selected, &.Mui-selected:hover': {
        color: 'white',
        backgroundColor: selectedColor,
    },
}));
export default function PrivacyRequest() {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [successOpen, setSuccessOpen] = React.useState(false);
    const [errorOpen, setErrorOpen] = React.useState(false);
    const [searchParams] = useSearchParams();
    const [successMessage, setSuccessMessage] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState(false);
    const [tenantName, setTenantName] = useState('');
    const [requestNotes, setRequestNotes] = useState('');
    const [cloudHosted, setCloudHosted] = useState(false);
    const [cloudProviderItems, setCloudProviderItems] = useState(false);
    const [collectionModeItems, setCollectionModeItems] = useState(false);
    const [dataCollectionOpen, setDataCollectionOpen] = useState(true);
    const [generalOpen, setGeneralOpen] = useState(true);
    const [studentInfoSelected, setstudentInfoSelected] = useState([]);
    const [staffInfoSelected, setstaffInfoSelected] = useState([]);
    const [studentInfoNASelected, setstudentInfoNASelected] = useState(false);
    const [staffInfoNASelected, setstaffInfoNASelected] = useState(false);
    const [parentInfoNASelected, setparentInfoNASelected] = useState(false);
    const [studentItems, setStudentItems] = useState(false);
    const [staffItems, setStaffItems] = useState(false);
    const [parentInfoSelected, setparentInfoSelected] = useState([]);
    const [parentItems, setParentItems] = useState(false);
    const [alumniInfoSelected, setalumniInfoSelected] = useState([]);
    const [alumniItems, setAlumniItems] = useState(false);
    const [volunteerItems, setVolunteerItems] = useState(false);
    const [alumniInfoNASelected, setalumniInfoNASelected] = useState(false);
    const [dataProtectionOpen, setDataProtectionOpen] = useState(true);
    const [subcontractorDataProtection, setSubcontractorDataProtection] = useState(false);
    const [otherAuditShow, setotherAuditShow] = useState(false);
    const [auditFrequencyList, setAuditFrequencyList] = useState(false);
    const [lastAuditDate, setLastAuditDate] = React.useState('');
    const [dataHandlingOpen, setDataHandlingOpen] = useState(true);
    const [dataSinglePurpose, setDataSinglePurpose] = React.useState(false);
    const [dataLocationSelected, setdataLocationSelected] = useState([]);
    const [dataLocationItems, setdataLocationItems] = useState([]);
    const [complianceOpen, setComplianceOpen] = useState(true);
    const [otherOpen, setOtherOpen] = useState(true);
    const [gDPRCompliant, setgDPRCompliant] = useState(false);
    const [internetPIPublished, setinternetPIPublished] = useState(false);
    const [dataBreachCompliant, setdataBreachCompliant] = useState(false);
    const [collectionModesSelected, setCollectionModesSelected] = useState([]);
    const [commonSense, setCommonSense] = useState('0');
    const [cloudProviderOtherShow, setCloudProviderOtherShow] = useState(false);
    const [cloudProviderOtherValue, setCloudProviderOtherValue] = useState('');
    const [volunteerInfoSelected, setVolunteerInfoSelected] = useState([]);
    const [volunteerInfoNASelected, setVolunteerInfoNASelected] = useState(false);
    const [policyLastUpdated, setPolicyLastUpdated] = React.useState('');
    const [genAIOpen, setGenAIOpen] = useState(false);
    const [hasExternalLLMs, setHasExternalLLMs] = useState(false);
    const [llmTraining, setllmTraining] = useState('');
    const [llmDataShared, setllmDataShared] = useState(false);
    const [securityBreachInt, setSecurityBreachInt] = useState(false);
    const [readOnly, setReadOnly] = useState(false);


    const handleCommonSenseChange = (event, newValue) => {

        setCommonSense(newValue);
    };


    const requestCode = searchParams.get("id");
    const titleBoxBackgroundColour = '#1976d21a'; //TODO: move this (and the one on the apps page to a common location)

    const HandleChange = (event) => {
        useHandleMultiSelectChange(event, null, setstudentInfoSelected, setstaffInfoSelected, setparentInfoSelected, setalumniInfoSelected, null, setdataLocationSelected, null, setstudentInfoNASelected, setstaffInfoNASelected, setparentInfoNASelected, setalumniInfoNASelected, null, setCollectionModesSelected, setVolunteerInfoSelected, setVolunteerInfoNASelected);// setotherDepartmentsShow, setCollectionModesSelected, setVolunteerInfoSelected, setVolunteerInfoNASelected, result);
    };


    const validationSchema = Yup.object().shape({
        requestId: Yup.number(),
        name: Yup.string()
            .required('Application Name is required')
            .max(250, 'Application Name must not exceed 250 characters'),
        url: Yup.string()
            .required('URL is required')
            .min(6, 'URL must be at least 6 characters')
            .max(150, 'URL must not exceed 150 characters')
            .matches(UrlRe, 'URL is not valid'),
        description: Yup.string()
            .required('Application Description is required')
            .max(1000, 'Application Description must not exceed 1000 characters'),
        cloudHosted: Yup.boolean()
            .typeError('Cloud Hosted must be Yes or No'),
        cloudProviderId: Yup.number(),
        collectionModeId: Yup.number()
            .nullable(),
        otherCollection: Yup.string()
            .nullable()
            .max(1000, 'Other field must not exceed 1000 characters'),
        privacyNotification: Yup.string()
            .nullable()
            .max(1000, 'Other field must not exceed 1000 characters'),
        privacyTraining: Yup.string()
            .nullable()
            .max(1000, 'Privacy Training field must not exceed 1000 characters'),
        subcontractors: Yup.string()
            .nullable()
            .max(1000, 'Subcontractor field must not exceed 1000 characters'),
        subcontractorDataProtection: Yup.number()
            .nullable()
            .typeError('Subcontractor Data Protection  must be Yes or No'),
        dataSinglePurpose: Yup.boolean()
            .nullable()
            .typeError('Data Single Purpose must be Yes or No'),
        auditFrequencyId: Yup.string()
            .nullable(),
        auditFrequencyOther: Yup.string()
            .nullable()
            .max(150, 'Field must not exceed 150 characters'),
        lastAuditDate: Yup.string()
            .nullable()
            .test("lastAuditDate", "Invalid Date - please correct", function (val) {
                return !(val === 'Invalid Date');
            }),
        securityBreachPlan: Yup.string()
            .nullable()
            .max(1000, 'Security Breach Plan must not exceed 1000 characters'),
        privacyPracticeReview: Yup.string()
            .nullable()
            .max(1000, 'Privacy Practice Review must not exceed 1000 characters'),
        vendorSaleAssurance: Yup.string()
            .nullable()
            .max(1000, 'Vendor Sales Assurance must not exceed 1000 characters'),
        dataBackup: Yup.string()
            .nullable()
            .max(1000, 'Data Backup and storage must not exceed 1000 characters'),
        lossProtection: Yup.string()
            .nullable()
            .max(1000, 'Loss Protection must not exceed 1000 characters'),
        dataRetentionPolicy: Yup.string()
            .nullable()
            .max(1000, 'Data Retention Policy must not exceed 1000 characters'),
        dataRetentionLength: Yup.string()
            .nullable()
            .max(500, 'Data Retention Length must not exceed 500 characters'),
        dataAfterDiscontinuing: Yup.string()
            .nullable()
            .max(2500, 'Data Discontuance must not exceed 1000 characters'),
        gDPRCompliant: Yup.boolean(),
        internetPIPublished: Yup.boolean(),
        generalApplicationNotes: Yup.string()
            .nullable()
            .max(2000, 'General Application Notes must not exceed 2000 characters'),
        gDPRCompliant: Yup.boolean()
            .nullable(),
        privacyTraining: Yup.string()
            .nullable()
            .max(1000, 'Privacy Training must not exceed 1000 characters'),
        securityBreachPlan: Yup.string()
            .nullable()
            .max(1000, 'Security Breach Plan must not exceed 1000 characters'),
        auditFrequencyOther: Yup.string()
            .nullable(true)
            .max(150, 'Other Audit Frequency must not exceed 150 characters')
            .when("auditFrequencyId", {
                is: (val) => val === -1,
                then: Yup.string().required("Other is selected, please provide other value"),
                otherwise: Yup.string().notRequired().nullable(),
            }),
        hasExternalLLMs: Yup.boolean()
            .nullable()
            .typeError('External LLMs must be Yes or No'),
        llmProviders: Yup.string()
            .nullable()
            .max(1000, 'LLM Providers must not exceed 1000 characters'),
        llmTraining: Yup.boolean()
            .nullable()
            .typeError('LLM Training must be Yes or No'),
        llmDataShared: Yup.boolean()
            .nullable()
            .typeError('LLM Data Shared must be Yes or No'),
        llmUnder18Treatment: Yup.string()
            .nullable()
            .max(1000, 'LLM Under 18 Treatment must not exceed 1000 characters'),
        llmRestrict: Yup.string()
            .nullable()
            .max(1000, 'Restriction approach must not exceed 1000 characters'),
        securityBreachDescription: Yup.string()
                    .nullable()
                    .max(1000, 'Security Breach Description must not exceed 1000 characters'),

    });

    const handleChipDelete = (event, value, stateFunction) => {
        event.preventDefault();
        stateFunction((current) => _without(current, value));
    };

    const {
        register,
        control,
        setValue,
        getValues,
        handleSubmit,
        //clearErrors,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(validationSchema)
    });

    //const [currentErrors, setCurrentErrors] = useState([]);
    // const seeErrors = (data) => {

    //     validationSchema
    //         .validate(data, { abortEarly: false })
    //         .then((responseData) => {
    //             console.log("no validation errors");
    //             console.log(responseData);
    //             //setCurrentErrors([]);
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //             console.log(err.name); // ValidationError
    //             console.log(err.errors);
    //             //setCurrentErrors(err.errors);
    //         });
    //     let errors = Object.values(data);
    //     //console.log(errors);
    //     errors.forEach((item) => {
    //         //console.log(item.message);
    //     });

    //     // errors.forEach((error) => {
    //     //     let elements = Object.keys(error);
    //     //     elements.forEach((item) => {
    //     //         console.log(item.message);

    //     //     })
    //     //     // console.log(`There are ${data[error]} ${error}`);
    //     //   })

    // };


    const MenuProps = useMenuItemProps();

    useEffect(() => {
        setLoading(true);

        fetch(`./public/privacyrequest?id=${requestCode}`)
            .then(res => res.json())
            .then(
                (result) => {
                    //console.log(result);
                    setLoading(false);
                    if (result.status === 2) { //request closed  
                        showError("This request is closed.")
                        setReadOnly(true);
                        
                    }
                    if (result.statusCode === 500) {
                        showError('Unable to fetch request.  Please try again later.');
                    }

                    setTenantName(result.tenantName);
                    setRequestNotes(result.notes);
                    //setValue('applicationName', result.applicationName ?? '');
                    setValue('requestId', result.requestId);
                    setValue('name', result.name ?? '');
                    setValue('url', result.url ?? '');
                    setValue('description', result.description ?? '');
                    setValue('cloudHosted', result.cloudHosted);
                    setCloudHosted(result.cloudHosted);
                    setValue('cloudProviderId', result.cloudProviderId ?? '');
                    //debugger;
                    // setValue('collectionModeId', result.collectionModeId===0 ? '': result.collectionModeId);
                    setValue('collectionModeId', result.collectionModeId);
                    setCloudProviderItems(result.cloudProviderItems);
                    setCollectionModeItems(result.collectionModeItems ?? '');
                    setStudentItems(result.studentInfoList);
                    setStaffItems(result.staffInfoList);
                    setParentItems(result.staffInfoList);
                    setAlumniItems(result.alumniInfoList);
                    setVolunteerItems(result.volunteerInfoList);
                    setValue('otherCollection', result.otherCollection ?? '');
                    setValue('privacyNotification', result.privacyNotification);
                    setValue('privacyTraining', result.privacyTraining);
                    setValue('subcontractors', result.subcontractors);
                    setValue('subcontractorDataProtection', result.subcontractorDataProtection);
                    setSubcontractorDataProtection(result.subcontractorDataProtection);
                    setValue('auditFrequencyId', result.auditFrequencyId);
                    setAuditFrequencyList(result.auditFrequencyItems);
                    setValue('auditFrequencyOther', result.auditFrequencyOther);
                    setValue('lastAuditDate', result.lastAuditDate);
                    setLastAuditDate(result.lastAuditDate);
                    setValue('securityBreachPlan', result.securityBreachPlan);
                    setValue('privacyPracticeReview', result.privacyPracticeReview);
                    setValue('vendorSaleAssurance', result.vendorSaleAssurance);
                    setValue('dataBackup', result.dataBackup);
                    setValue('lossProtection', result.lossProtection);
                    setDataSinglePurpose(result.dataSinglePurpose);
                    setdataLocationItems(result.dataLocationItems);
                    setValue('dataRetentionPolicy', result.dataRetentionPolicy);
                    setValue('dataRetentionLength', result.dataRetentionLength ?? '');
                    setValue('dataAfterDiscontinuing', result.dataAfterDiscontinuing);
                    setValue("dataSinglePurpose", result.dataSinglePurpose);
                    setValue('gDPRCompliant', result.gDPRCompliant ?? false);
                    setgDPRCompliant(result.gDPRCompliant ?? false);
                    setinternetPIPublished(result.internetPIPublished ?? false);
                    setValue('internetPIPublished', result.internetPIPublished ?? false);
                    setdataBreachCompliant(result.dataBreachCompliant);
                    setValue('generalApplicationNotes', result.generalApplicationNotes);
                    setValue('dataBreachCompliant', result.dataBreachCompliant);
                    setValue('gDPRCompliant', result.gDPRCompliant);
                    setValue('privacyTraining', result.privacyTraining);
                    setValue('securityBreachPlan', result.securityBreachPlan);
                    setValue("securityBreachDescription", result.securityBreachDescription);
                    setHasExternalLLMs(result.hasExternalLLMs);
                    setValue("llmProviders", result.llmProviders);
                    setValue("llmTraining", result.llmTraining === true);
                    setllmTraining(result.llmTraining === true);
                    setValue("llmDataShared", result.llmDataShared === true);
                    setllmDataShared(result.llmDataShared === true);
                    setValue("llmUnder18Treatment", result.llmUnder18Treatment);
                    setValue("llmRestrict", result.llmRestrict);
                    setValue("dataCollectionNotes", result.dataCollectionNotes);
                    setValue("dataProtectionNotes", result.dataProtectionNotes);
                    setValue("dataHandlingNotes", result.dataHandlingNotes);
                    setValue("complianceNotes", result.complianceNotes);
                    setPolicyLastUpdated(result.policyLastUpdated);
                    setSecurityBreachInt(result.securityBreachInt);


                    setCommonSense(result.commonSense);
                    if (result.policyLastUpdated === '') {
                        setPolicyLastUpdated(null);
                    }
                    else {
                        setPolicyLastUpdated(result.policyLastUpdated);
                    }


                    if (result.auditFrequencyId === null) {
                        setValue("auditFrequencyId", '');
                    }
                    else {
                        setValue("auditFrequencyId", result.auditFrequencyId);
                    }

                    if (result.auditFrequencyId === -1) { //other    
                        setotherAuditShow(true);
                    }

                    if (result.studentInfoSelected === null) {
                        setstudentInfoSelected([]);
                    } else {
                        setstudentInfoSelected(result.studentInfoSelected ?? '');
                    }

                    if (result.staffInfoSelected === null) {
                        setstaffInfoSelected([]);
                    } else {
                        setstaffInfoSelected(result.staffInfoSelected ?? '');
                    }
                    if (result.parentInfoSelected === null) {
                        setparentInfoSelected([]);
                    } else {
                        setparentInfoSelected(result.parentInfoSelected ?? '');
                    }
                    if (result.alumniInfoSelected === null) {
                        setalumniInfoSelected([]);
                    } else {
                        setalumniInfoSelected(result.alumniInfoSelected ?? '');
                    }
                    if (result.volunteerInfoSelected === null) {
                        setVolunteerInfoSelected([]);
                    } else {
                        setVolunteerInfoSelected(result.volunteerInfoSelected ?? '');
                    }


                    if (result.dataLocationsSelected === null) {
                        setdataLocationSelected([]);
                    } else {
                        setdataLocationSelected(result.dataLocationsSelected ?? '');
                    }
                    if (result.collectionModesSelected === null) {
                        setCollectionModesSelected([]);
                    } else {
                        setCollectionModesSelected(result.collectionModesSelected);
                    }
                    // var otherCloudProvider = cloudProviderItems.find(x => x.name === 'Other');
                    // //set the value of the 'Other' option
                    // if (otherCloudProvider) {
                    //     setCloudProviderOtherValue(otherCloudProvider.lookupItemId);

                    //     setCloudProviderOtherShow(result.cloudProviderId === otherCloudProvider.lookupItemId);
                    // }
                    //console.log(result);
                    //setItems(result);
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    setLoading(false);
                    setError(error);
                }
            )
    }, [setLoading, requestCode, setValue])

    // const convertNamesToId = (selected, items) => {

    //     var selectedIds = [];
    //     debugger;
    //     selected.map(findId);

    //     function findId(value) {
    //         for (var i = 0; i < items.length; i++) {
    //             if (items[i].name === value) {
    //                 selectedIds.push(items[i].lookupItemId);
    //             }
    //         }
    //     }
    //     return selectedIds;

    // };

    async function saveRequest(request, option) {


        var method = '';
        var url = ''
        request.saveOption = option;
        method = 'POST';
        url = 'public/saveRequest/';
        request.studentInfoSelected = studentInfoSelected;
        request.staffInfoSelected = staffInfoSelected;
        request.parentInfoSelected = parentInfoSelected;
        request.alumniInfoSelected = alumniInfoSelected;
        request.volunteerInfoSelected = volunteerInfoSelected;
        request.commonSense = commonSense;
        request.securityBreachInt = securityBreachInt;

        request.collectionModesSelected = collectionModesSelected;
        request.dataLocationsSelected = dataLocationSelected;
        request.policyLastUpdated = policyLastUpdated;

        //request.gDPRCompliant = gDPRCompliant;
        //request.internetPIPublished = internetPIPublished;


        if (request.lastAuditDate !== null && request.lastAuditDate !== '') {
            request.lastAuditDate = new Date(request.lastAuditDate).toISOString();
        }
        else {
            request.lastAuditDate = null;
        }
        if (request.auditFrequencyId === '') {
            request.auditFrequencyId = null;
        }
        //console.log(request);
        //debugger;
        try {
            const requestOptions = {
                method: method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(request)
            };

            fetch(url, requestOptions).then(res => res.json())
                .then(
                    (result) => {

                        if (result !== true) {
                            //if (result.statusCode === 500) {
                            showError('Unable to save request.  Please try again later.');
                        } else {
                            switch (option) {
                                case 0:
                                    showSuccess("Update Successful.  Use the same URL anytime to edit further.");
                                    break;
                                case 1:
                                    showSuccess("Data successfully submitted. This request is now closed.");
                                    break;
                                default:
                                    showSuccess("Update Successful");
                            }
                        }
                    },
                    (error) => {
                        // setLoading(false);
                        setError(error);
                    }
                );

        } catch (e) {

            showError();
        } finally {

        }
    }
    const handleAuditFrequencyChange = (e) => {

        setValue('auditFrequencyId', e.target.value, { shouldValidate: true });
        if (e.target.value === -1) {
            setotherAuditShow(true);
            setValue('auditFrequencyId', e.target.value, { shouldValidate: true });
        }
        else {
            setotherAuditShow(false);
            setValue('auditFrequencyId', e.target.value, { shouldValidate: false }, { required: false });
        }
    }
    const handleCloudProviderChange = (event, cloudProviderOtherValue) => {

        setValue('cloudProviderId', event.target.value, { shouldValidate: true });
        setCloudProviderOtherShow(event.target.value === cloudProviderOtherValue);
    }

    const showSuccess = message => {
        setSuccessOpen(true);
        setSuccessMessage(message);
        setTimeout(() => setSuccessOpen(false), 3000);
    };

    const showError = (message) => {
        setErrorOpen(true);
        setErrorMessage(message);
        setTimeout(() => setErrorOpen(false), 3000);
    };


    if (loading) {
        return (
            <div>
                Loading...
            </div>
        );
    }
    if (error !== null) { //TODO:replace with proper error
        return (
            <div>
                An error occured
            </div>
        );
    }

    const closeSuccess = () => {
        setSuccessOpen(false);
    };



    function onSubmit(data) {

        saveRequest(data, 0);
    }

    const onSave = data => {
        saveRequest(data, 1);
    };
    // const handleSubContractorChange = (event) => {
    //     setSubcontractorDataProtection(event.target.checked);
    // };
    // const handleDataSinglePurposeChange = (event) => {
    //     setDataSinglePurpose(event.target.checked);
    // };
    const showSelectedNames = (selectedIds) => {
        var selectedNames = [];

        for (var i = 0; i < selectedIds.length; i++) {
            for (var j = 0; j < dataLocationItems.length; j++) {
                if (selectedIds[i] === dataLocationItems[j].lookupItemId) {
                    selectedNames.push(dataLocationItems[j].name);
                }
            }
        }
        return selectedNames.join(', ');
    };
    const handleGdprChange = (event) => {
        setgDPRCompliant(event.target.checked);
    };
    const handleinternetPiChange = (event) => {
        setinternetPIPublished(event.target.checked);
    };

    const handleDataBreachCompliantChange = (event) => {
        setdataBreachCompliant(event.target.checked);
    };
    const handleSecurityBreachChange = (event, setFunction) => {
        setFunction(event.target.value);
    };
    // const handleDataLocationChange = (item) => {
    //     debugger;
    //     setdataLocationSelected(
    //         // On autofill we get a stringified value.

    //     );
    // };
    // const setCloudHosted = (value) =>{

    //     setValue('cloudHosted', value);
    // };
    return (
        <div >
            <div className="alert-fixed">
                <SuccessError
                    successMessage={successMessage}
                    errorMessage={errorMessage}
                    //closeError={() => closeError()}
                    closeSuccess={() => closeSuccess()}
                    successOpen={successOpen}
                    errorOpen={errorOpen}
                >
                </SuccessError>
            </div>
            {!errorOpen &&
                <Fragment>
                    <Box
                        component="span"
                        m={1}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Typography variant="h4" component="h3">
                            Privacy Data Request
                        </Typography>
                        <Typography variant="inherit" >
                            {tenantName} has requested information regarding : {requestNotes}
                        </Typography>

                    </Box>

                    <form>
                        <Grid item xs={12} sm={12}>
                            <TextField
                                // required
                                id="requestId"
                                name="requestId"
                                label="ID"
                                fullWidth
                                hidden
                                margin="dense"
                                {...register('requestId')}

                            />
                            <Typography variant="inherit" color="error.main">
                                {errors.requestId?.message}
                            </Typography>
                        </Grid>
                        <Box px={1} py={0}>

                            <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                onClick={() => setGeneralOpen(!generalOpen)}
                            >
                                <Grid container sx={{ justifyContent: "space-between" }} >
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        General Application Information
                                    </Typography>

                                </Grid>
                            </Box>


                            <Collapse in={generalOpen} width={'100%'}>
                                <Box sx={{ border: 1 }} px={1} py={2}>
                                    <Grid container spacing={2} >

                                        <Grid item xs={4}>
                                            <TextField
                                                required
                                                id="name"
                                                name="name"
                                                label="Application Name"
                                                fullWidth
                                                margin="dense"
                                                {...register('name')}
                                                error={errors.applicationName ? true : false}
                                            />
                                            <Typography variant="inherit" color="error.main">
                                                {errors.name?.message}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <TextField
                                                required
                                                id="url"
                                                name="url"
                                                label="Application URL or Vendor URL"
                                                fullWidth
                                                margin="dense"
                                                {...register('url')}
                                                error={errors.url ? true : false}
                                            />
                                            <Typography variant="inherit" color="error.main">
                                                {errors.url?.message}
                                            </Typography>
                                        </Grid>
                                        {/* <Grid item xs={2.9} sm={2.9} md={2.9}>
                                            <InputLabel sx={{ paddingTop: 1.5, paddingRight: 0, paddingLeft: 1 }}>Common Sense Media:</InputLabel>
                                        </Grid>
                                        <Grid item xs={3.9} sm={3.9} md={3.9} >

                                            <FormControl>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-radio-buttons-group-label"

                                                    name="radio-buttons-group"

                                                >
                                                    <ToggleButtonGroup value={commonSense} exclusive onChange={handleCommonSenseChange}>
                                                        <ToggleButton value={2} selectedColor="green">
                                                            Pass
                                                        </ToggleButton>
                                                        <ToggleButton value={1} selectedColor="orange">
                                                            Warning
                                                        </ToggleButton>
                                                        <ToggleButton value={0} selectedColor="Red">
                                                            Fail
                                                        </ToggleButton>
                                                        <ToggleButton value={4} selectedColor="Grey">
                                                            N/A
                                                        </ToggleButton>

                                                    </ToggleButtonGroup>
                                                </RadioGroup>
                                            </FormControl>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.commonSense?.message}
                                            </Typography>

                                        </Grid>
                                        <Grid item xs={4.5} sm={4.5} md={4.5} >
                                            <TextField

                                                id="url"
                                                name="url"
                                                label="CSM Software Evaluation URL"
                                                fullWidth
                                                //margin="dense"
                                                {...register('evalUrl')}
                                                error={errors.evalUrl ? true : false}
                                            />
                                            <Typography variant="inherit" color="error.main">
                                                {errors.evalUrl?.message}
                                            </Typography>
                                        </Grid> */}

                                        <Grid item xs={12} sm={12} md={12}>
                                            <SelfSizingTextField
                                                required
                                                initialValue={getValues('description')}
                                                maxSize={1000}
                                                errors={errors.description}
                                                register={register}
                                                name="description"
                                                id="description"
                                                label="Description of Application"
                                                placeholder="Description of Application"

                                            ></SelfSizingTextField>
                                        </Grid>
                                        <Grid item xs={3} sm={3} md={3}>
                                            <FormControl>
                                                <FormLabel id="demo-radio-buttons-group-label">Cloud Hosted</FormLabel>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-radio-buttons-group-label"

                                                    name="radio-buttons-group"

                                                    onChange={(e) => handleBooleanRadioButtonChange(e, setCloudHosted)}
                                                >

                                                    <FormControlLabel {...register('cloudHosted')} key='1' value={'1'} checked={cloudHosted} control={<Radio />} label="Yes" />
                                                    <FormControlLabel {...register('cloudHosted')} key='0' value={'0'} checked={cloudHosted === false} control={<Radio />} label="No" />

                                                </RadioGroup>
                                            </FormControl>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.cloudHosted?.message}
                                            </Typography>
                                            {/* <FormControlLabel control={<Switch
                                                //initialC = {getValues('cloudHosted')}
                                                checked={cloudHosted}
                                                onChange={(e) => handleCloudHostedChange(e, setCloudHosted)}
                                                name="cloudHosted"

                                            />}
                                                label="Cloud Hosted"
                                                {...register('cloudHosted')}
                                            /> */}

                                        </Grid>
                                        {cloudHosted &&
                                            <Grid item xs={3} sm={3}>
                                                <FormControl sx={{ m: 0, minWidth: 200, paddingTop: 1 }}>

                                                    <InputLabel >Cloud Provider</InputLabel>
                                                    <Controller
                                                        name="cloudProviderId"
                                                        control={control}

                                                        render={({ field: { onChange, value } }) => (
                                                            <Select

                                                                value={value}
                                                                label="Cloud Provider"
                                                                onChange={e => handleCloudProviderChange(e, cloudProviderOtherValue)}
                                                            >
                                                                {cloudProviderItems.map((mode, index) => <MenuItem key={index} value={mode.lookupItemId}>{mode.name}</MenuItem>)}

                                                            </Select>
                                                        )}
                                                    />
                                                </FormControl>
                                                <Typography variant="inherit" color="error.main">
                                                    {errors.cloudProviderId?.message}
                                                </Typography>


                                            </Grid>
                                        }
                                        {cloudHosted && cloudProviderOtherShow &&
                                            <Fragment>
                                                <Grid item xs={3} sm={3}>
                                                    <FormControl sx={{ m: 0, minWidth: 350 }}>
                                                        <TextField
                                                            // disabled={!currentUser.isSuperAdmin}
                                                            id="cloudProvider"
                                                            name="cloudProvider"
                                                            label="Other Cloud Provider"
                                                            fullWidth
                                                            margin="dense"
                                                            {...register('cloudProvider')}
                                                            error={errors.cloudProvider ? true : false}
                                                        />
                                                    </FormControl>
                                                    <Typography variant="inherit" color="error.main">
                                                        {errors.cloudProvider?.message}
                                                    </Typography>


                                                </Grid>
                                                <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                                    <Tooltip title="What cloud service is hosting the application? ">
                                                        <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                                    </Tooltip>
                                                </Grid>
                                            </Fragment>
                                        }
                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="inherit">
                                                Organizations need to know how their users, particularly those below 18, are connected to your systems
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={12} sm={12}>
                                            <FormControl sx={{ m: 0, minWidth: 200 }}>
                                                <MultiSelectWithChips
                                                    label="Collection Mode"
                                                    name="collectionModesSelected"
                                                    control={control}
                                                    value={collectionModesSelected}
                                                    infoSelected={collectionModesSelected}
                                                    //infoNASelected={studentInfoNASelected}
                                                    setinfoSelected={setCollectionModesSelected}
                                                    onChange={HandleChange}
                                                    handleChipDelete={handleChipDelete}
                                                    errors={errors.collectionModesSelected}

                                                    items={collectionModeItems}
                                                >
                                                </MultiSelectWithChips>
                                                {/* <InputLabel>Collection Mode </InputLabel>
                                                <Controller
                                                    name="collectionModeId"
                                                    control={control}
                                                    defaultValue=""
                                                    // {...register("vendor")}
                                                    render={({ field: { onChange, value } }) => (
                                                        <Select
                                                            defaultValue={0}
                                                            value={value}
                                                            label="Collection Mode"
                                                            onChange={(e) => setValue('collectionModeId', e.target.value, { shouldValidate: true })}
                                                        >
                                                            {collectionModeItems.map((mode, index) => <MenuItem key={index} value={mode.lookupItemId}>{mode.name}</MenuItem>)}

                                                        </Select>
                                                    )}
                                                /> */}
                                            </FormControl>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.itOwner?.message}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="inherit">
                                                Any other information that organizations need to know, in particular if there is anything particular about the cloud hosting situation, or how information on user accounts is collected.
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={11}>

                                            <SelfSizingTextField
                                                required={false}
                                                initialValue={getValues('generalApplicationNotes')}
                                                maxSize={2000}
                                                errors={errors.generalApplicationNotes}
                                                register={register}
                                                name="generalApplicationNotes"
                                                id="generalApplicationNotes"
                                                label="General Application Notes"
                                                placeholder="General Application Notes"

                                            ></SelfSizingTextField>

                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="Any other general information that is needed to be kept by the school.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={12} />


                                    </Grid>
                                </Box>
                            </Collapse>
                            <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                onClick={() => setDataCollectionOpen(!dataCollectionOpen)}
                            >
                                <Grid container sx={{ justifyContent: "space-between" }}>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        Data Collection
                                    </Typography>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        {dataCollectionOpen ? <RemoveIcon /> : <AddIcon />}

                                    </Typography>
                                </Grid>
                            </Box>
                            <Collapse in={dataCollectionOpen} width={'100%'}>
                                <Box sx={{ border: 1 }} px={1} py={2}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12}>
                                            <Typography variant="inherit">
                                                Organizations need to know all of the fields that you are connecting, particularly for students under the age of 18.  Please identify these below and, if the data collection is more than firstname, lastname, and email, please give a description of why that information is needed in the Notes area at the bottom of this section.
                                            </Typography>
                                        </Grid>
                                        {/* <Grid item xs={12} /> */}
                                        <Grid item xs={6} sm={6}>
                                            <MultiSelectWithChips
                                                label="Student Information"
                                                name="studentInfoSelected"
                                                control={control}
                                                value={studentInfoSelected}
                                                infoSelected={studentInfoSelected}
                                                infoNASelected={studentInfoNASelected}
                                                setinfoSelected={setstudentInfoSelected}
                                                onChange={HandleChange}
                                                handleChipDelete={handleChipDelete}
                                                errors={errors.studentInfoSelected}
                                                items={studentItems}
                                            >
                                            </MultiSelectWithChips>
                                        </Grid>
                                        <Grid item xs={6} sm={6}>
                                            <MultiSelectWithChips
                                                label="Employee Information "
                                                name="staffInfoSelected"
                                                control={control}
                                                value={staffInfoSelected}
                                                infoSelected={staffInfoSelected}
                                                infoNASelected={staffInfoNASelected}
                                                setinfoSelected={setstaffInfoSelected}
                                                onChange={HandleChange}
                                                handleChipDelete={handleChipDelete}
                                                errors={errors.staffInfoSelected}
                                                items={staffItems}
                                            >
                                            </MultiSelectWithChips>

                                        </Grid>
                                        <Grid item xs={6} sm={6}>
                                            <MultiSelectWithChips
                                                label="Parent/Guardian Information"
                                                name="parentInfoSelected"
                                                control={control}
                                                value={parentInfoSelected}
                                                infoSelected={parentInfoSelected}
                                                infoNASelected={parentInfoNASelected}
                                                setinfoSelected={setparentInfoSelected}
                                                onChange={HandleChange}
                                                handleChipDelete={handleChipDelete}
                                                errors={errors.parentInfoSelected}
                                                items={parentItems}
                                            >
                                            </MultiSelectWithChips>

                                            <Typography variant="inherit" color="error.main">
                                                {errors.parentInfoSelected?.message}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={6} sm={6}>
                                            <MultiSelectWithChips
                                                label="Alumni Information"
                                                name="alumniInfoSelected"
                                                control={control}
                                                value={alumniInfoSelected}
                                                infoSelected={alumniInfoSelected}
                                                infoNASelected={alumniInfoNASelected}
                                                setinfoSelected={setalumniInfoSelected}
                                                onChange={HandleChange}
                                                handleChipDelete={handleChipDelete}
                                                errors={errors.parentInfoSelected}
                                                items={alumniItems}
                                            >
                                            </MultiSelectWithChips>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.alumniInfoSelected?.message}
                                            </Typography>

                                        </Grid>
                                        <Grid item xs={3}>
                                            <MultiSelectWithChips
                                                label="Volunteer Information"
                                                name="volunteerInfoSelected"
                                                control={control}
                                                value={volunteerInfoSelected}
                                                infoSelected={volunteerInfoSelected}
                                                infoNASelected={volunteerInfoNASelected}
                                                setinfoSelected={setVolunteerInfoSelected}
                                                onChange={HandleChange}
                                                handleChipDelete={handleChipDelete}
                                                errors={errors.volunteerInfoSelected}
                                                items={volunteerItems}
                                            >
                                            </MultiSelectWithChips>


                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "10px" }}>
                                            <Tooltip title="Private volunteer data fields that are sent to the 3rd party application.  ">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={12} sm={12}></Grid>


                                        {/* <TextField
                                                InputLabelProps={{ shrink: true }}
                                                placeholder="Cookies, other information collected etc."
                                                id="other"
                                                name="otherCollection"
                                                label="Other"
                                                fullWidth
                                                margin="dense"
                                                {...register('otherCollection')}
                                                error={errors.otherCollection ? true : false}
                                            /> */}
                                        <Grid item xs={12} sm={12} md={12}>
                                            <SelfSizingTextField
                                                initialValue={getValues('otherCollection')}
                                                errors={errors.privacyNotification}
                                                register={register}
                                                maxSize={1000}
                                                name="otherCollection"
                                                id="otherCollection"
                                                label="Other"
                                                placeholder="Cookies, other information collected etc."
                                                error={errors.otherCollection ? true : false}
                                            ></SelfSizingTextField>
                                        </Grid>
                                        <Typography variant="inherit" color="error.main">
                                            {errors.otherCollection?.message}
                                        </Typography>
                                        <Grid item xs={11}>

                                            <SelfSizingTextField
                                                required={false}
                                                initialValue={getValues('dataCollectionNotes')}
                                                maxSize={2000}
                                                errors={errors.dataCollectionNotes}
                                                register={register}
                                                name="dataCollectionNotes"
                                                id="dataCollectionNotes"
                                                label="Data Collection Notes"
                                                placeholder="Data Collection Notes"

                                            ></SelfSizingTextField>

                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="Any other data collection information that is needed to be kept by the school.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>

                                    </Grid>

                                </Box>
                            </Collapse>
                            <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                onClick={() => setDataProtectionOpen(!dataProtectionOpen)}
                            >
                                <Grid container sx={{ justifyContent: "space-between" }}>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        Data Protection
                                    </Typography>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        {dataProtectionOpen ? <RemoveIcon /> : <AddIcon />}

                                    </Typography>

                                </Grid>
                            </Box>
                            <Collapse in={dataProtectionOpen} width={'100%'}>
                                <Box sx={{ border: 1 }} px={1} py={2}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <SelfSizingTextField
                                                initialValue={getValues('privacyNotification')}
                                                errors={errors.privacyNotification}
                                                register={register}
                                                maxSize={1000}
                                                name="privacyNotification"
                                                id="privacyNotification"
                                                label="Privacy Notification"
                                                placeholder="How does your company notify customers of privacy policy changes?"
                                            ></SelfSizingTextField>
                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4}>
                                            <LocalizationProvider xs={6} dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    inputFormat="MMM-YYYY"
                                                    views={['month', 'year']}
                                                    id="policyLastUpdated"
                                                    name="policyLastUpdated"
                                                    label="Privacy Policy Last Updated"
                                                    //{...register('policyLastUpdated')}
                                                    value={policyLastUpdated}

                                                    onChange={(newValue) => {
                                                        //debugger;
                                                        setPolicyLastUpdated(newValue);
                                                    }}
                                                    renderInput={(params) => <TextField  {...params} />}
                                                />
                                            </LocalizationProvider>

                                            <Typography variant="inherit" color="error.main">
                                                {errors.policyLastUpdated?.message}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <SelfSizingTextField
                                                initialValue={getValues('subcontractors')}
                                                errors={errors.subcontractors}
                                                register={register}
                                                maxSize={1000}
                                                name="subcontractors"
                                                id="subcontractors"
                                                label="Subcontractors"
                                                placeholder="List subcontractors who have access to data"
                                            ></SelfSizingTextField>
                                        </Grid>
                                        {/* <Grid item xs={4} sm={4} md={4}>

                                            <FormControl>
                                                <Tooltip arrow sx={{ padding: 0 }} placement="bottom-start" title="Are all subcontractors outlined above required to protect personally identifiable data in accordance with applicable privacy laws and privacy/security industry best practice?">
                                                    <FormLabel id="demo-radio-buttons-group-label">Subcontractors are vetted to ensure data is protected</FormLabel>
                                                </Tooltip>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-radio-buttons-group-label"

                                                    name="radio-buttons-group"

                                                    onChange={(e) => handleBooleanRadioButtonChange(e, setSubcontractorDataProtection)}
                                                >

                                                    <FormControlLabel {...register('subcontractorDataProtection')} key='1' value={1} checked={subcontractorDataProtection} control={<Radio />} label="Yes" />
                                                    <FormControlLabel {...register('subcontractorDataProtection')} key='0' value={0} checked={!subcontractorDataProtection} control={<Radio />} label="No" />


                                                </RadioGroup>
                                            </FormControl>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.subcontractorDataProtection?.message}
                                            </Typography>

                                        </Grid> */}
                                        <Grid item xs={12} sm={12} md={12}>

                                            <FormControl>
                                                <FormLabel id="demo-radio-buttons-group-label">Has the organization experienced a privacy breach in the past?</FormLabel>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-radio-buttons-group-label"

                                                    name="radio-buttons-group"
                                                    //{...register('subcontractorDataProtection')}
                                                    onChange={(e) => handleSecurityBreachChange(e, setSecurityBreachInt)}
                                                >
                                                    <FormControlLabel {...register('securityBreachInt')} key='1' value={'1'} checked={securityBreachInt == '1'} control={<Radio />} label="Yes" />
                                                    <FormControlLabel {...register('securityBreachInt')} key='0' value={'0'} checked={securityBreachInt == '0'} control={<Radio />} label="No" />
                                                    <FormControlLabel {...register('securityBreachInt')} key='-1' value={'-1'} checked={securityBreachInt == '-1'} control={<Radio />} label="Unknown" />

                                                </RadioGroup>
                                            </FormControl>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.securityBreachInt?.message}
                                            </Typography>
                                        </Grid>
                                        {securityBreachInt == '1' && (<Grid item xs={12} sm={12} md={12}>
                                            <SelfSizingTextField
                                                // disabled={!currentUser.isSuperAdmin}
                                                initialValue={getValues('securityBreachDescription')}
                                                errors={errors.securityBreachDescription}
                                                register={register}
                                                maxSize={1000}
                                                name="securityBreachDescription"
                                                id="securityBreachDescription"
                                                label="Security Breach Description"
                                                placeholder="If yes, please explain the incident"
                                            ></SelfSizingTextField>
                                        </Grid>)}

                                        {/* <Grid item xs={4} sm={4}>
                                            <FormControl sx={{ m: 0, minWidth: 220 }}>
                                                <InputLabel>Privacy Audit Frequency</InputLabel>
                                                <Controller
                                                    name="auditFrequencyId"
                                                    control={control}
                                                    //defaultValue=""
                                                    // {...register("vendor")}
                                                    render={({ field: { onChange, value } }) => (
                                                        <Select
                                                            defaultValue={0}
                                                            value={value}
                                                            label="Privacy Audit Frequency"
                                                            onChange={handleAuditFrequencyChange}
                                                        >
                                                            {auditFrequencyList.map((item, index) => <MenuItem key={index} value={item.lookupItemId}>{item.name}</MenuItem>)}

                                                        </Select>
                                                    )}
                                                />
                                            </FormControl>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.auditFrequencyId?.message}
                                            </Typography>

                                        </Grid> */}
                                        <Grid item xs={4} sm={4} md={4}>
                                            {otherAuditShow && (
                                                <TextField
                                                    InputLabelProps={{ shrink: true }}
                                                    id="auditFrequencyOther"
                                                    name="auditFrequencyOther"
                                                    label="Other"
                                                    placeholder="Other"
                                                    {...register('auditFrequencyOther')}
                                                />

                                            )}
                                            {otherAuditShow && (

                                                <Typography variant="inherit" color="error.main">
                                                    {errors.auditFrequencyOther?.message}
                                                </Typography>
                                            )}
                                        </Grid>
                                        {/* <Grid item xs={12} sm={12} md={12}> <FormLabel id="demo-radio-buttons-group-label2">Date of last cybersecurity audit/ PEN test</FormLabel>
                                        </Grid>
                                        <Grid item xs={8} sm={8} >

                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    id="lastAuditDate"
                                                    name="lastAuditDate"
                                                    label="Audit/PEN test date"
                                                    {...register('lastAuditDate')}
                                                    value={lastAuditDate}
                                                    onChange={(newValue) => {
                                                        setLastAuditDate(newValue);
                                                        setValue("lastAuditDate", newValue);
                                                    }}
                                                    renderInput={(params) => <TextField  {...params} />}
                                                />
                                            </LocalizationProvider>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.lastAuditDate?.message}
                                            </Typography>
                                        </Grid> */}
                                        <Grid item xs={12} sm={12} md={12}>
                                            <SelfSizingTextField
                                                initialValue={getValues('securityBreachPlan')}
                                                errors={errors.securityBreachPlan}
                                                register={register}
                                                maxSize={1000}
                                                name="securityBreachPlan"
                                                id="securityBreachPlan"
                                                label="Security Breach Plan"
                                                placeholder="What is the security breach plan and what is the notification timeline?"
                                            ></SelfSizingTextField>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <SelfSizingTextField
                                                initialValue={getValues('privacyPracticeReview')}
                                                errors={errors.privacyPracticeReview}
                                                register={register}
                                                maxSize={1000}
                                                name="privacyPracticeReview"
                                                id="privacyPracticeReview"
                                                label="Privacy Practice Review"
                                                placeholder="How often does your company review its privacy practices?"
                                            ></SelfSizingTextField>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <SelfSizingTextField
                                                initialValue={getValues('vendorSaleAssurance')}
                                                errors={errors.vendorSaleAssurance}
                                                register={register}
                                                maxSize={1000}
                                                name="vendorSaleAssurance"
                                                id="vendorSaleAssurance"
                                                label="Vendor Sale Assurance"
                                                placeholder="Is there an assurance that the privacy policy will stay in place until renewal if your company is sold?"
                                            ></SelfSizingTextField>
                                        </Grid>
                                        <Grid item xs={11}>

                                            <SelfSizingTextField
                                                required={false}
                                                initialValue={getValues('dataProtectionNotes')}
                                                maxSize={2000}
                                                errors={errors.dataProtectionNotes}
                                                register={register}
                                                name="dataProtectionNotes"
                                                id="dataProtectionNotes"
                                                label="Data Protection Notes"
                                                placeholder="Add any notes about the answers you have given above in the Data Protection section"

                                            ></SelfSizingTextField>

                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="Any other data protection information that is needed to be kept by the school.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>


                                    </Grid>
                                </Box>
                            </Collapse>
                            <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                onClick={() => setDataHandlingOpen(!dataHandlingOpen)}
                            >
                                <Grid container sx={{ justifyContent: "space-between" }}>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        Data Handling
                                    </Typography>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        {dataHandlingOpen ? <RemoveIcon /> : <AddIcon />}

                                    </Typography>

                                </Grid>
                            </Box>

                            <Collapse in={dataHandlingOpen} width={'100%'}>
                                <Box sx={{ border: 1 }} px={1} py={2}>
                                    <Grid container spacing={2}>



                                        <Grid item xs={12} sm={12} md={12}>

                                            <FormControl>
                                                <Tooltip arrow sx={{ padding: 0 }} placement="bottom-start" title="Are all subcontractors outlined above required to protect personally identifiable data in accordance with applicable privacy laws and privacy/security industry best practice?">
                                                    <FormLabel id="demo-radio-buttons-group-label">Your company confirms that data is not sold or used for anything other that what is stated in the privacy agreement</FormLabel>
                                                </Tooltip>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-radio-buttons-group-label"

                                                    name="radio-buttons-group"

                                                    onChange={(e) => handleBooleanRadioButtonChange(e, setDataSinglePurpose)}
                                                >

                                                    <FormControlLabel {...register('dataSinglePurpose')} key='1' value={1} checked={dataSinglePurpose} control={<Radio />} label="Yes" />
                                                    <FormControlLabel {...register('dataSinglePurpose')} key='0' value={0} checked={!dataSinglePurpose} control={<Radio />} label="No" />

                                                </RadioGroup>
                                            </FormControl>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.dataSinglePurpose?.message}
                                            </Typography>

                                        </Grid>
                                        {/* <Grid item xs={6} sm={6}>
                                            <MultiSelectWithChips
                                                label="Where does the data reside?"
                                                name="dataLocationSelected"
                                                control={control}
                                                value={dataLocationSelected}
                                                infoSelected={dataLocationSelected}
                                                infoNASelected={dataLocationSelected}
                                                setinfoSelected={setdataLocationSelected}
                                                onChange={HandleChange}
                                                handleChipDelete={handleChipDelete}
                                                errors={errors.dataLocationSelected}
                                                items={dataLocationItems}
                                            >
                                            </MultiSelectWithChips>
                                        </Grid> */}


                                        {/* MIGRATE TO MULTISELECTWITHCHIPS HERE?? */}

                                        <Grid item xs={4} sm={4}>
                                            <FormControl sx={{ m: 0, width: 250 }}>
                                                <InputLabel> Where does the data reside? </InputLabel>
                                                <Controller
                                                    name="dataLocationSelected"
                                                    control={control}
                                                    defaultValue=""
                                                    render={({ field: { onChange, value } }) => (
                                                        <Select
                                                            multiple
                                                            MenuProps={MenuProps}
                                                            name="dataLocationSelected"
                                                            value={dataLocationSelected}
                                                            label="Where does the data reside?"
                                                            input={<OutlinedInput label="Where does the data reside?" />}
                                                            //onChange={handleDataLocationChange}
                                                            onChange={HandleChange}
                                                            renderValue={(selected) => {
                                                                return showSelectedNames(selected);
                                                                //return "ewerwer";
                                                                //selected.join(',')
                                                            }
                                                            }
                                                        >
                                                            {dataLocationItems.map((item) => (
                                                                <MenuItem value={item.lookupItemId} key={item.lookupItemId} >
                                                                    <Switch checked={dataLocationSelected.indexOf(item.lookupItemId) > -1} />
                                                                    {<ListItemText primary={item.name} />}
                                                                </MenuItem>
                                                            ))}

                                                        </Select>
                                                    )}
                                                />
                                            </FormControl>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.dataLocationSelected?.message}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <SelfSizingTextField
                                                initialValue={getValues('dataRetentionPolicy')}
                                                errors={errors.dataRetentionPolicy}
                                                register={register}
                                                maxSize={1000}
                                                name="dataRetentionPolicy"
                                                id="dataRetentionPolicy"
                                                label="Data Retention Policy"
                                                placeholder="Describe the data retention policy for active and inactive accounts"
                                            ></SelfSizingTextField>
                                        </Grid>

                                        {/* <Grid item xs={8} sm={8} md={8}>
                                            <SelfSizingTextField
                                                initialValue={getValues('dataRetentionLength')}
                                                errors={errors.dataRetentionLength}
                                                register={register}
                                                maxSize={500}
                                                name="dataRetentionLength"
                                                id="dataRetentionLength"
                                                label="Data Retention Length"
                                                placeholder="How long is the data retained?"
                                            ></SelfSizingTextField>
                                        </Grid> */}

                                        <Grid item xs={12} sm={12} md={12}>
                                            <SelfSizingTextField
                                                initialValue={getValues('dataAfterDiscontinuing')}
                                                errors={errors.dataAfterDiscontinuing}
                                                register={register}
                                                maxSize={1000}
                                                name="dataAfterDiscontinuing"
                                                id="dataAfterDiscontinuing"
                                                label="Data Discontinuance"
                                                placeholder="What happens to the data if the customer no longer uses your product?"
                                            ></SelfSizingTextField>
                                        </Grid>
                                        <Grid item xs={11} >

                                            <SelfSizingTextField
                                                required={false}
                                                initialValue={getValues('dataHandlingNotes')}
                                                maxSize={2000}
                                                errors={errors.dataHandlingNotes}
                                                register={register}
                                                name="dataHandlingNotes"
                                                id="dataHandlingNotes"
                                                label="Data Handling Notes"
                                                placeholder="Add any notes about the answers you have given above in the Data Handling section."

                                            ></SelfSizingTextField>

                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="Add any notes about the answers you have given above in the Data Handling section.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Collapse>
                            <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                onClick={() => setComplianceOpen(!complianceOpen)}
                            >
                                <Grid container sx={{ justifyContent: "space-between" }}>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        Compliance
                                    </Typography>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        {otherOpen ? <RemoveIcon /> : <AddIcon />}

                                    </Typography>

                                </Grid>
                            </Box>
                            <Collapse in={complianceOpen} width={'100%'}>
                                <Box sx={{ border: 1 }} px={1} py={2}>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={12} md={12} paddingBottom={2}>
                                            <Typography variant="inherit">
                                                Currently, it is not mandatory in Canada for 3rd party apps to be GDPR compliant.  We use this standard, however, because Canadian privacy laws are changing and the will be most in-line with GDPR when passed.  It is also considered the global gold standard.  This application uses it accordingly until the Canadian laws change.
                                            </Typography>
                                        </Grid>

                                        <Grid item xs={6} sm={6} md={6} >

                                            <FormControl>
                                                <Tooltip arrow sx={{ padding: 0 }} placement="bottom-start" title=" The General Data Protection Regulation (GDPR) is the toughest privacy and security law in the world. Though it was drafted and passed by the European Union (EU), it imposes obligations onto organizations anywhere, so long as they target or collect data related to people in the EU.">
                                                    <FormLabel id="gdpr-label">Software is GDPR Compliant</FormLabel>
                                                </Tooltip>
                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-radio-buttons-group-label"

                                                    name="gDPRCompliant"
                                                    {...register('gDPRCompliant')}
                                                    //onChange={handleGdprChange}
                                                    onChange={(e) => {

                                                        handleBooleanRadioButtonChange(e, setgDPRCompliant);

                                                    }}
                                                >
                                                    <FormControlLabel {...register('gDPRCompliant')} key='1' value={'1'} checked={gDPRCompliant} control={<Radio />} label="Yes" />
                                                    <FormControlLabel {...register('gDPRCompliant')} key='0' value={'0'} checked={gDPRCompliant === false} control={<Radio />} label="No" />

                                                </RadioGroup>
                                            </FormControl>

                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <SelfSizingTextField
                                                initialValue={getValues('privacyTraining')}
                                                errors={errors.privacyTraining}
                                                register={register}
                                                maxSize={1000}
                                                name="privacyTraining"
                                                id="privacyTraining"
                                                label="Privacy Training"
                                                placeholder="How does your company ensure employees are trained to handle private data?"
                                            ></SelfSizingTextField>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <SelfSizingTextField
                                                initialValue={getValues('securityBreachPlan')}
                                                errors={errors.privacyPolicy}
                                                register={register}
                                                maxSize={1000}
                                                name="securityBreachPlan"
                                                id="securityBreachPlan"
                                                label="Security Breach Plan"
                                                placeholder="What is the security breach plan and what is the notification timeline?"
                                            ></SelfSizingTextField>
                                        </Grid>
                                        <Grid item xs={2} sm={2}>
                                            <FormControl sx={{ m: 0, minWidth: 220 }}>
                                                <InputLabel>Privacy Audit Frequency</InputLabel>
                                                <Controller
                                                    name="auditFrequencyId"
                                                    control={control}

                                                    render={({ field: { onChange, value } }) => (
                                                        <Select

                                                            defaultValue={0}
                                                            value={value}
                                                            label="Privacy Audit Frequency"
                                                            onChange={handleAuditFrequencyChange}
                                                        >
                                                            {auditFrequencyList.map((item, index) => <MenuItem key={index} value={item.lookupItemId}>{item.name}</MenuItem>)}

                                                        </Select>
                                                    )}
                                                />
                                            </FormControl>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.auditFrequencyId?.message}
                                            </Typography>


                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="The audit frequency is done with an external vendor.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={6} sm={6} md={6}>
                                            {otherAuditShow && (
                                                <TextField
                                                    fullWidth
                                                    // disabled={!currentUser.isSuperAdmin}
                                                    InputLabelProps={{ shrink: true }}
                                                    id="auditFrequencyOther"
                                                    name="auditFrequencyOther"
                                                    label="Other"
                                                    placeholder="Other"
                                                    {...register('auditFrequencyOther')}
                                                />

                                            )}
                                            {otherAuditShow && (

                                                <Typography variant="inherit" color="error.main">
                                                    {errors.auditFrequencyOther?.message}
                                                </Typography>
                                            )}
                                        </Grid>
                                        <Grid item xs={12} sm={12}  >
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DatePicker
                                                    // disabled={!currentUser.isSuperAdmin}
                                                    id="lastAuditDate"
                                                    name="lastAuditDate"
                                                    label="Date of Last Audit"
                                                    {...register('lastAuditDate')}
                                                    value={lastAuditDate}
                                                    onChange={(newValue) => {
                                                        setLastAuditDate(newValue);
                                                        setValue("lastAuditDate", newValue);
                                                    }}
                                                    renderInput={(params) => <TextField  {...params} />}
                                                />
                                            </LocalizationProvider>
                                            <Typography variant="inherit" color="error.main">
                                                {errors.lastAuditDate?.message}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={12}>
                                            <SelfSizingTextField
                                                initialValue={getValues('dataBackup')}
                                                errors={errors.dataBackup}
                                                register={register}
                                                maxSize={1000}
                                                name="dataBackup"
                                                id="dataBackup"
                                                label="Data Backup and Storage"
                                                placeholder="How is the data stored and how is it backed up?"
                                            ></SelfSizingTextField>
                                        </Grid>


                                        <Grid item xs={12} sm={12} md={12}>
                                            <SelfSizingTextField
                                                initialValue={getValues('lossProtection')}
                                                errors={errors.lossProtection}
                                                register={register}
                                                maxSize={1000}
                                                name="lossProtection"
                                                id="lossProtection"
                                                label="Data Loss Protection"
                                                placeholder="How is the data and the data backups protected from loss, theft and/or unauthorized access? (SIEM, encrypted in transit/at rest; password complexity etc.)"
                                            ></SelfSizingTextField>
                                        </Grid>
                                        <Grid item xs={4} sm={4} md={4}>
                                            <Tooltip arrow sx={{ padding: 0 }} placement="bottom-start" title="For example, sharing to social media networks">
                                                <FormControlLabel control={<Switch
                                                    checked={internetPIPublished ?? false}
                                                    onChange={handleinternetPiChange}
                                                    name="internetPipublished"

                                                />}
                                                    label="Software allows for sharing of personal information with other companies (like athletic results)"
                                                    {...register('internetPipublished')}
                                                />
                                            </Tooltip>
                                        </Grid>
                                        <Grid item xs={11}>

                                            <SelfSizingTextField
                                                required={false}
                                                initialValue={getValues('complianceNotes')}
                                                maxSize={2000}
                                                errors={errors.complianceNotes}
                                                register={register}
                                                name="complianceNotes"
                                                id="complianceNotes"
                                                label="Compliance Notes"
                                                placeholder="Compliance Notes"

                                            ></SelfSizingTextField>

                                        </Grid>
                                        <Grid item xs={1} sm={1} md={1} style={{ paddingTop: "20px", paddingRight: 0, paddingLeft: "5px" }}>
                                            <Tooltip title="Any other data compliance information that is needed to be kept by the school.">
                                                <HelpCenterOutlinedIcon fontSize="small" color="primary" />
                                            </Tooltip>
                                        </Grid>

                                    </Grid>
                                </Box>
                            </Collapse>
                            <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                onClick={() => setGenAIOpen(!genAIOpen)}
                            >
                                <Grid container sx={{ justifyContent: "space-between" }}>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        Generative AI
                                    </Typography>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        {otherOpen ? <RemoveIcon /> : <AddIcon />}

                                    </Typography>

                                </Grid>
                            </Box>
                            <Collapse in={genAIOpen} width={'100%'}>
                                <Box sx={{ border: 1 }} px={1} py={2}>

                                    <Grid container spacing={2}>
                                        <Grid item xs={6} sm={6} md={6}>

                                            <FormControl>

                                                <FormLabel id="gdpr-label">Does your company rely on external LLMs? </FormLabel>

                                                <RadioGroup
                                                    row
                                                    aria-labelledby="demo-radio-buttons-group-label"

                                                    name="hasExternalLLMs"
                                                    {...register('hasExternalLLMs')}
                                                    //onChange={handleGdprChange}
                                                    onChange={(e) => {

                                                        handleBooleanRadioButtonChange(e, setHasExternalLLMs);

                                                    }}
                                                >

                                                    <FormControlLabel {...register('hasExternalLLMs')} key='1' value={'1'} checked={hasExternalLLMs} control={<Radio />} label="Yes" />
                                                    <FormControlLabel {...register('hasExternalLLMs')} key='0' value={'0'} checked={hasExternalLLMs === false} control={<Radio />} label="No" />

                                                </RadioGroup>
                                            </FormControl>

                                        </Grid>

                                        {hasExternalLLMs &&

                                            <Fragment>
                                                <Grid item xs={11}>

                                                    <SelfSizingTextField
                                                        required={false}
                                                        initialValue={getValues('llmProviders')}
                                                        maxSize={1000}
                                                        errors={errors.LLMProviders}
                                                        register={register}
                                                        name="llmProviders"
                                                        id="llmProviders"
                                                        label="Which Providers is your company hosted with?"
                                                        placeholder="Which Providers is your company hosted with?"

                                                    ></SelfSizingTextField>

                                                </Grid>
                                                <Grid item xs={6} sm={6} md={6}>

                                                    <FormControl>

                                                        <FormLabel id="gdpr-label">Do your LLM providers train their general models on the queries submitted? </FormLabel>

                                                        <RadioGroup
                                                            row
                                                            aria-labelledby="demo-radio-buttons-group-label"

                                                            name="llmTraining"
                                                            {...register('llmTraining')}
                                                            //onChange={handleGdprChange}
                                                            onChange={(e) => {

                                                                handleBooleanRadioButtonChange(e, setllmTraining);

                                                            }}
                                                        >

                                                            <FormControlLabel {...register('llmTraining')} key='1' value={'1'} checked={llmTraining} control={<Radio />} label="Yes" />
                                                            <FormControlLabel {...register('llmTraining')} key='0' value={'0'} checked={llmTraining === false} control={<Radio />} label="No" />

                                                        </RadioGroup>
                                                    </FormControl>

                                                </Grid>
                                                <Grid item xs={6} sm={6} md={6}>

                                                    <FormControl>

                                                        <FormLabel id="gdpr-label">Are the models trained with this data shared with other clients? </FormLabel>

                                                        <RadioGroup
                                                            row
                                                            aria-labelledby="demo-radio-buttons-group-label"

                                                            name="llmDataShared"
                                                            {...register('llmDataShared')}
                                                            //onChange={handleGdprChange}
                                                            onChange={(e) => {

                                                                handleBooleanRadioButtonChange(e, setllmDataShared);

                                                            }}
                                                        >

                                                            <FormControlLabel {...register('llmDataShared')} key='1' value={'1'} checked={llmDataShared} control={<Radio />} label="Yes" />
                                                            <FormControlLabel {...register('llmDataShared')} key='0' value={'0'} checked={llmDataShared === false} control={<Radio />} label="No" />

                                                        </RadioGroup>
                                                    </FormControl>

                                                </Grid>
                                                <Grid item xs={11}>

                                                    <SelfSizingTextField
                                                        required={false}
                                                        initialValue={getValues('llmUnder18Treatment')}
                                                        maxSize={1000}
                                                        errors={errors.llmUnder18Treatment}
                                                        register={register}
                                                        name="llmUnder18Treatment"
                                                        id="llmUnder18Treatment"
                                                        label="Does your company treat the data differently if the user is under 18?"
                                                        placeholder="Does your company treat the data differently if the user is under 18?"

                                                    ></SelfSizingTextField>

                                                </Grid>
                                                <Grid item xs={11}>

                                                    <SelfSizingTextField
                                                        required={false}
                                                        initialValue={getValues('llmRestrict')}
                                                        maxSize={1000}
                                                        errors={errors.llmRestrict}
                                                        register={register}
                                                        name="llmRestrict"
                                                        id="llmRestrict"
                                                        label="What approach is taken to restrict access to training and inference data within your company?"
                                                        placeholder="What approach is taken to restrict access to training and inference data within your company?"

                                                    ></SelfSizingTextField>

                                                </Grid>
                                            </Fragment>
                                        }
                                    </Grid>


                                </Box>

                            </Collapse>
                            {/* <Box sx={{ border: 1, backgroundColor: titleBoxBackgroundColour }} px={2} py={1}
                                onClick={() => setOtherOpen(!otherOpen)}
                            >
                                <Grid container sx={{ justifyContent: "space-between" }}>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        Other
                                    </Typography>
                                    <Typography variant="inherit" sx={{ fontWeight: 'bold' }}>
                                        {otherOpen ? <RemoveIcon /> : <AddIcon />}

                                    </Typography>

                                </Grid>
                            </Box>
                            <Collapse in={otherOpen} width={'100%'}>
                                <Box sx={{ border: 1 }} px={1} py={2}>
                                    <Typography variant="inherit">
                                        Hover over items to show expanded information
                                    </Typography>


                                    <Grid item xs={4} sm={4} md={4}>
                                        <Tooltip arrow sx={{ padding: 0 }} placement="bottom-start" title=" The General Data Protection Regulation (GDPR) is the toughest privacy and security law in the world. Though it was drafted and passed by the European Union (EU), it imposes obligations onto organizations anywhere, so long as they target or collect data related to people in the EU.">
                                            <FormControlLabel control={<Switch
                                                checked={gDPRCompliant ?? false}
                                                onChange={handleGdprChange}
                                                name="gDPRCompliant"

                                            />}
                                                label="Software is compliant with GDPR"
                                                {...register('gDPRCompliant')}
                                            />
                                        </Tooltip>

                                    </Grid>
                                  
                                    <Grid item xs={4} sm={4} md={4}>
                                        <Tooltip arrow sx={{ padding: 0 }} placement="bottom-start" title="Confirm Compliance With ​Canada’s Data Privacy Act ​And ​PIPEDA​ Request For Mandatory Reporting Of A Data Breach ​“To Inform Individuals If Their Personal Information Has Been Lost, Stolen Or Inappropriately Accessed, And They Are Placed At Risk Of Harm.” Is This Articulated In Terms Of Service?">
                                            <FormControlLabel control={<Switch
                                                checked={dataBreachCompliant ?? false}
                                                onChange={handleDataBreachCompliantChange}
                                                name="dataBreachCompliant"

                                            />}
                                                label="Data Breach Compliance"
                                                {...register('dataBreachCompliant')}
                                            />
                                        </Tooltip>
                                    </Grid>

                                </Box>
                            </Collapse> */}
                        </Box>
                        <Box
                            m={1}
                            //margin
                            display="flex"
                            justifyContent="flex-end"
                            alignItems="flex-end"

                        >
                            {/* <Button variant="outlined" onClick={handleSubmit(onSubmit, seeErrors)}>Save and Finish Later</Button> */}
                            {!readOnly && (
                                <>
                                    <Button variant="outlined" onClick={handleSubmit(onSubmit)}>Save and Finish Later</Button>
                                    <Button variant="outlined" onClick={handleSubmit(onSave)}>Save and Submit</Button>
                                </>
                            )}
                            {/* <Button onClick={runValidations}>run validations</Button> */}
                            {/* <Button color="primary" onClick={handleSubmit(onSubmit)}>Save and Finish Later</Button>
                            <Button onClick={handleCancel}>Save and Submit</Button> */}
                        </Box>

                    </form>
                </Fragment>
            }

        </div >

    );
}